import MarketingPageLayout from "../components/MarketingPageLayout";
import SeoHelmet from "../components/SeoHelmet";
import MarketingHero from "../components/MarketingHero";
import FeatureCardGrid from "../components/FeatureCardGrid";
import { BarChart3, CalendarClock, Timer, TrendingUp, Brain, LineChart, Building2 } from "lucide-react";
import InternalLinks from "../components/InternalLinks";
import CtaFinal from "../components/CtaFinal";
import { MARKETING_META } from "../seoMeta";
import { FEATURE_SOFTWARE_LD } from "../data/featurePages";
import useTranslation from "../../client/hooks/useTranslation";

const PATH = "/fonctionnalites/analytics-trading";

export default function FeatureAnalyticsPage() {
  const t = useTranslation();
  const m = MARKETING_META[PATH];
  const c = t.marketing.features.analytics;
  return (
    <MarketingPageLayout>
      <SeoHelmet path={PATH} title={m.title} description={m.description} jsonLd={[FEATURE_SOFTWARE_LD]} />
      <MarketingHero h1={c.h1} subtitle={c.subtitle} />
      <FeatureCardGrid
        bullets={c.bullets}
        image="/images/features/analytics.png"
        imageAlt={c.h1}
        icons={[BarChart3, CalendarClock, Timer, LineChart, Brain, TrendingUp, Building2]}
      />
      <InternalLinks
        links={[
          { to: "/tarifs", label: t.marketing.nav.pricing },
          { to: "/journal-de-trading", label: t.marketing.nav.megaFeatures[0].label },
          { to: "/fonctionnalites/sessions-de-trading", label: t.marketing.nav.megaFeatures[3].label },
        ]}
      />
      <CtaFinal />
    </MarketingPageLayout>
  );
}
